export default {
  confirmUpdate: 'Uložiť zmeny v tomto recepte?',
  recipeExists: 'Recept existuje',
  recipeName: 'Názov receptúry',
};
